export const RolePermission = Object.freeze({
  CREATE: 'CREATE',
  BETA_VIEW: 'BETA_VIEW',
  BETA_EDIT: 'BETA_EDIT',
  VIEW: 'VIEW',
  /** 管理员权限，编辑项目相关的一些重要配置。目前业务中绝大部分要求管理员才能操作的功能都是基于这个权限。 */
  EDIT: 'EDIT',
  CRASH_VIEW: 'CRASH_VIEW',
  CRASH_EDIT: 'CRASH_EDIT',
  VIEW_DETAIL: 'VIEW_DETAIL',
  VIEW_PERSONAL_DATA: 'VIEW_PERSONAL_DATA',
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  /** （元梦需求）大盘统计，查看场景维度统计结果的权限 */
  VIEW_DASHBOARD_USER_SCENE_TAG: 'VIEW_DASHBOARD_USER_SCENE_TAG',
  VIEW_APP_GENERAL_CONFIG: 'VIEW_APP_GENERAL_CONFIG',

  /** app group管理员特有的权限 */
  APP_GROUP_CREATE: 'APP_GROUP_CREATE',
});
